import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { environment } from '../../environments/environment';

import { ActiveErrorsEffects } from './active-errors/active-errors.effects';
import { activeErrorsReducer } from './active-errors/active-errors.reducer';
import { AssistantEffects, assistantReducer } from './assistant';
import { AuthEffects } from './auth/auth.effects';
import { authReducer } from './auth/auth.reducer';
import { BookingEffects } from './booking/booking.effects';
import { bookingReducer } from './booking/booking.reducer';
import { CommercialEffects } from './commercial';
import { commercialReducer } from './commercial/commercial.reducer';
import { configurationReducer } from './configuration/configuration.reducer';
import { DashboardEffects, dashboardReducer } from './dashboard';
import { DepartmentEffects } from './department/department.effects';
import { departmentReducer } from './department/department.reducer';
import { DevicesEffects } from './devices/devices.effects';
import { devicesReducer } from './devices/devices.reducer';
import { DiagStackDtcEffects, diagStackDtcReducer } from './diag-stack-dtc';
import { DiagStackOtxEffects, diagStackOtxReducer } from './diag-stack-otx';
import { DocumentsEffects } from './documents/documents.effects';
import { documentsReducer } from './documents/documents.reducer';
import { EnergyHistoricalDataEffects } from './energy-historical-data/energy-historical-data.effects';
import { energyHistoricalDataReducer } from './energy-historical-data/energy-historical-data.reducer';
import { ErrorDetailsEffects } from './error-details/error-details.effects';
import { errorDetailsReducer } from './error-details/error-details.reducer';
import { EventsEffects } from './events/events.effects';
import { eventsReducer } from './events/events.reducer';
import { FirmwareUpdateEffects } from './firmware-update/firmware-update.effects';
import { firmwareUpdateReducer } from './firmware-update/firmware-update.reducer';
import { GatewayCommissioningEffects } from './gateway-commissioning/gateway-commissioning.effects';
import { gatewayCommissioningReducer } from './gateway-commissioning/gateway-commissioning.reducer';
import { GatewayInvitationsEffects } from './gateway-invitations/gateway-invitations.effects';
import { gatewayInvitationsReducer } from './gateway-invitations/gateway-invitations.reducer';
import { GatewayEffects } from './gateway/gateway.effects';
import { gatewayReducer } from './gateway/gateway.reducer';
import { GatewaysEffects } from './gateways/gateways.effects';
import { gatewaysReducer } from './gateways/gateways.reducer';
import { HemsEffects } from './hems/hems.effects';
import { hemsReducer } from './hems/hems.reducer';
import { HydraulicSchematicEffects } from './hydraulic-schematic/hydraulic-schematic.effects';
import { hydraulicSchematicReducer } from './hydraulic-schematic/hydraulic-schematic.reducer';
import { InformationPopupEffects, informationPopupReducer } from './information-popup';
import { InstallationDetailsEffects } from './installation-details/installation-details.effects';
import { installationDetailsReducer } from './installation-details/installation-details.reducer';
import { InstallationsMigrationEffects } from './installations-migration/installations-migration.effects';
import { installationsMigrationReducer } from './installations-migration/installations-migration.reducer';
import { InstallationsSearchEffects } from './installations-search/installations-search.effects';
import { installationsSearchReducer } from './installations-search/installations-search.reducer';
import { InstallationsEffects } from './installations/installations.effects';
import { installationsReducer } from './installations/installations.reducer';
import { InvitationsEffects } from './invitations/invitations.effects';
import { invitationsReducer } from './invitations/invitations.reducer';
import { MapEffects } from './map/map.effects';
import { mapReducer } from './map/map.reducer';
import { NewInvitationEffects } from './new-invitation/new-invitation.effects';
import { newInvitationReducer } from './new-invitation/new-invitation.reducer';
import { NoteEffects } from './note/note.effects';
import { noteReducer } from './note/note.reducer';
import { OperatingModesEffects } from './operating-modes/operating-modes.effects';
import { operatingModesReducer } from './operating-modes/operating-modes.reducer';
import { RefrigerationCircuitMessagesEffects } from './refrigeration-circuit-messages/refrigeration-circuit-messages.effects';
import { refrigerationCircuitMessagesReducer } from './refrigeration-circuit-messages/refrigeration-circuit-messages.reducer';
import { RemoteConfigEffects } from './remote-config/remote-config.effects';
import { remoteConfigReducer } from './remote-config/remote-config.reducer';
import { RemoteDiagnosticsEffects } from './remote-diagnostics';
import { RemoteDiagnosticsSnapshotsEffects } from './remote-diagnostics-snapshots';
import { remoteDiagnosticsSnapshotsReducer } from './remote-diagnostics-snapshots/remote-diagnostics-snapshots.reducer';
import { RemoteDiagnosticsUseCasesEffects } from './remote-diagnostics-use-cases/remote-diagnostics-use-cases.effects';
import { remoteDiagnosticsUseCasesReducer } from './remote-diagnostics-use-cases/remote-diagnostics-use-cases.reducer';
import { remoteDiagnosticsReducer } from './remote-diagnostics/remote-diagnostics.reducer';
import { remoteServiceReducer } from './remote-service';
import { RemoteServiceEffects } from './remote-service/remote-service.effects';
import { SearchEffects } from './search/search.effects';
import { searchReducer } from './search/search.reducer';
import { backendStorageReducer } from './settings/backend-storage';
import { BackendStorageEffects } from './settings/backend-storage/backend-storage.effects';
import { languageReducer } from './settings/language';
import { LanguageEffects } from './settings/language/language.effects';
import { NotificationsEffects } from './settings/notifications/notifications.effects';
import { notificationsReducer } from './settings/notifications/notifications.reducer';
import { UnitsEffects } from './settings/units/units.effects';
import { unitsReducer } from './settings/units/units.reducer';
import { CommissioningEffects } from './commissioning/commissioning.effects';
import { commissioningReducer } from './commissioning/commissioning.reducer';
import { StatusPageEffects } from './status-page/status-page.effects';
import { statusPageReducer } from './status-page/status-page.reducer';
import { TrendingEffects } from './trending/trending.effects';
import { trendingReducer } from './trending/trending.reducer';
import { UpdatesEffects } from './updates/updates.effects';
import { updatesReducer } from './updates/updates.reducer';
import { UserDetailsEffects } from './user-details/user-details.effects';
import { userDetailsReducer } from './user-details/user-details.reducer';
import { UsersListEffects } from './users/users.effects';
import { usersListReducer } from './users/users.reducer';
import { VddDetailsListEffects } from './vdd-details-list/vdd-details-list.effects';
import { vddDetailsListReducer } from './vdd-details-list/vdd-details-list.reducer';
import { VouchersEffects } from './vouchers/vouchers.effects';
import { vouchersReducer } from './vouchers/vouchers.reducer';
import { smartHomeComponentsReducer, SmartHomeComponentsEffects } from './smart-home-components';
import {
  ViguideRecommendationsEffects,
  viguideRecommendationsReducer,
} from './viguide-recommendations';
import { GatewayFirmwareUpdateEffects } from './gateway-firmware-update/gateway-firmware-update.effects';
import { gatewayFirmwareUpdateReducer } from './gateway-firmware-update/gateway-firmware-update.reducer';
import { AnalyticsEffects, analyticsReducer } from './analytics';
import { KanbanBoardEffects, kanbanBoardReducer } from './kanban-board';
import { demoSettingsReducer } from './demo-settings/demo-settings.reducer';
import { DemoSettingsEffects } from './demo-settings/demo-settings.effects';
import { installationFeaturesReducer } from './installation-features/installation-features.reducer';
import { InstallationFeaturesEffects } from './installation-features/installation-features.effects';
import { ServiceTicketEffects } from './service-ticket/service-ticket.effects';
import { serviceTicketReducer } from './service-ticket';
import { powerLimitationHistoryReducer } from './power-limitation-history/power-limitation-history.reducer';
import { PowerLimitationHistoryEffects } from './power-limitation-history/power-limitation-history.effects';
import { TutorialsEffects, tutorialsReducer } from '@store';

export let STORE_DEV_TOOLS = [];
if (environment.reduxDevTool) {
  STORE_DEV_TOOLS = [
    StoreDevtoolsModule.instrument({
      maxAge: 300,
      connectInZone: true,
    }),
  ];
}

@NgModule({
  imports: [
    StoreModule.forRoot(
      {
        activeErrors: activeErrorsReducer,
        analytics: analyticsReducer,
        assistant: assistantReducer,
        auth: authReducer,
        backendStorage: backendStorageReducer,
        booking: bookingReducer,
        commercial: commercialReducer,
        commissioning: commissioningReducer,
        configuration: configurationReducer,
        dashboard: dashboardReducer,
        demoSettings: demoSettingsReducer,
        departments: departmentReducer,
        devices: devicesReducer,
        diagStackDtc: diagStackDtcReducer,
        diagStackOtx: diagStackOtxReducer,
        documents: documentsReducer,
        energyHistoricalData: energyHistoricalDataReducer,
        errorDetails: errorDetailsReducer,
        events: eventsReducer,
        firmwareUpdate: firmwareUpdateReducer,
        gateway: gatewayReducer,
        gatewayCommissioning: gatewayCommissioningReducer,
        gatewayFirmwareUpdate: gatewayFirmwareUpdateReducer,
        gatewayInvitations: gatewayInvitationsReducer,
        gateways: gatewaysReducer,
        hems: hemsReducer,
        hydraulicSchematic: hydraulicSchematicReducer,
        informationPopup: informationPopupReducer,
        installationDetails: installationDetailsReducer,
        installationFeatures: installationFeaturesReducer,
        installations: installationsReducer,
        installationsMigration: installationsMigrationReducer,
        installationsSearch: installationsSearchReducer,
        invitations: invitationsReducer,
        kanbanBoard: kanbanBoardReducer,
        language: languageReducer,
        map: mapReducer,
        newInvitation: newInvitationReducer,
        note: noteReducer,
        notifications: notificationsReducer,
        operatingModes: operatingModesReducer,
        powerLimitationHistory: powerLimitationHistoryReducer,
        refrigerationCircuitMessages: refrigerationCircuitMessagesReducer,
        remoteConfig: remoteConfigReducer,
        remoteDiagnostics: remoteDiagnosticsReducer,
        remoteDiagnosticsSnapshots: remoteDiagnosticsSnapshotsReducer,
        remoteDiagnosticsUseCases: remoteDiagnosticsUseCasesReducer,
        remoteService: remoteServiceReducer,
        router: routerReducer,
        searchList: searchReducer,
        serviceTicket: serviceTicketReducer,
        smartHomeComponents: smartHomeComponentsReducer,
        status: statusPageReducer,
        trending: trendingReducer,
        tutorials: tutorialsReducer,
        units: unitsReducer,
        updates: updatesReducer,
        userDetails: userDetailsReducer,
        usersList: usersListReducer,
        vddDetailsList: vddDetailsListReducer,
        viguideRecommendations: viguideRecommendationsReducer,
        vouchers: vouchersReducer,
      },
      {
        runtimeChecks: {
          strictStateImmutability: false,
          strictActionImmutability: false,
        },
      }
    ),
    StoreRouterConnectingModule.forRoot(),
    EffectsModule.forRoot([
      ActiveErrorsEffects,
      AnalyticsEffects,
      AssistantEffects,
      AuthEffects,
      BackendStorageEffects,
      BookingEffects,
      CommercialEffects,
      CommissioningEffects,
      DashboardEffects,
      DemoSettingsEffects,
      DepartmentEffects,
      DevicesEffects,
      DiagStackDtcEffects,
      DiagStackOtxEffects,
      DocumentsEffects,
      EnergyHistoricalDataEffects,
      ErrorDetailsEffects,
      EventsEffects,
      FirmwareUpdateEffects,
      GatewayCommissioningEffects,
      GatewayEffects,
      GatewayFirmwareUpdateEffects,
      GatewayInvitationsEffects,
      GatewaysEffects,
      HemsEffects,
      HydraulicSchematicEffects,
      InformationPopupEffects,
      InstallationDetailsEffects,
      InstallationFeaturesEffects,
      InstallationsEffects,
      InstallationsMigrationEffects,
      InstallationsSearchEffects,
      InvitationsEffects,
      KanbanBoardEffects,
      LanguageEffects,
      MapEffects,
      NewInvitationEffects,
      NoteEffects,
      NotificationsEffects,
      OperatingModesEffects,
      PowerLimitationHistoryEffects,
      RefrigerationCircuitMessagesEffects,
      RemoteConfigEffects,
      RemoteDiagnosticsEffects,
      RemoteDiagnosticsSnapshotsEffects,
      RemoteDiagnosticsUseCasesEffects,
      RemoteServiceEffects,
      SearchEffects,
      ServiceTicketEffects,
      SmartHomeComponentsEffects,
      StatusPageEffects,
      TrendingEffects,
      TutorialsEffects,
      UnitsEffects,
      UpdatesEffects,
      UserDetailsEffects,
      UsersListEffects,
      VddDetailsListEffects,
      ViguideRecommendationsEffects,
      VouchersEffects,
    ]),
    ...STORE_DEV_TOOLS,
  ],
})
export class AppStoreModule {}
